import $ from 'jquery';
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Toasted from 'vue-toasted';
import { initClient } from '../../../api';
import { Duty, DutyClient } from "../../backend/backendapi";
import { massEditDuty } from "../dutyui.util";

Vue.use(Toasted, { duration: 2000 });

@Component({
    name: 'DisabledModal',
    components: {}
})
export default class DisabledModal extends Vue {
    @Prop({ required: true })
    readonly duties!: Duty[];

    private disabled: boolean = false;

    open(): void {
        $(this.$refs.modal!).modal('show');
        setTimeout(() => (this.$refs.checkbox as HTMLElement).focus(), 500);
        this.selectMostCommonValue();
    }

    dismiss(): void {
        $(this.$refs.modal!).modal('hide');
    }

    private async save(): Promise<void> {
        const stats = await massEditDuty(this.duties, (dutyCreate) => {
            dutyCreate.duty.isDisabled = this.disabled;
        }, this.$toasted, this.$i18n);
        this.$emit('saved', stats);
        if (stats.failed === 0) {
            this.dismiss();
        }
    }
    
    private selectMostCommonValue(): void {
        const indeterminate = this.duties.some(e => e.isDisabled) && this.duties.some(e => !e.isDisabled);
        if (indeterminate) {
            (this.$refs.checkbox as HTMLInputElement).indeterminate = true;
        }
    }
}